module.exports = __webpack_public_path__ + "static/media/eina04-bold.fad4bcb9.woff2";